export function isEntity(e: unknown): e is Entity {
  return Object.prototype.hasOwnProperty.call(e, 'id');
}
